import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Activity from './Activity';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '300px',
    minHeight: '250px',
    maxHeight: '250px',
    padding: '20px',
    marginBottom: '30px',
    borderRadius: 'unset',
    overflow: 'auto'
  }
}));

const RecentActivity = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <h3>Recent Activity</h3>
      <Activity activity="Fidelity signed NDA" date="Today" today />
      <Activity activity="BlackRock declined opportunity" date="March 10" />
      <Activity activity="Truffle downloaded deal data" date="March 12" />
    </Paper>
  );
};

export default RecentActivity;
